import { compose, equals, head, tail, merge } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import NumberInput from '../../modules/numberInput.jsx';
import XTNA from './XTNA';
import Chart from './Chart.jsx'
import '../app.scss';

export default class XTNAChartDataForm extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
  }
  render() {
    const getPropNames = (type) => XTNA.props().filter(compose(equals(type), head));
    const naturalProps = getPropNames('N');
    const adaptedProps = getPropNames('A');

    return (
      <table className='input-table' style={{ marginBottom: '10px' }}>
        <thead>
          <tr>
            <td />
            {naturalProps.map(compose((prop) => <td key={prop}>{prop}</td>, tail))}
          </tr>
        </thead>
        <tbody>
          <tr><td><b>Natural</b></td>{naturalProps.map(this.renderField)}</tr>
          <tr><td><b>Adaptado</b></td>{adaptedProps.map(this.renderField)}</tr>
        </tbody>
      </table>
    );
  }
  renderField(field) {
    const cell = this.props.editable === false ?
      this.props.value[field] : 
      <NumberInput className='form-control' onChange={this.handleChange(field)} value={this.props.value[field]} min='1' max='9' />;
      
    return <td key={field}>{cell}</td>;
  }
  handleChange(field) {
    return (value) => {
      this.props.onChange(merge(this.props.value, { [field]: value, valid: true }));
    };
  }
}



// WEBPACK FOOTER //
// ./src/App/xtna/Form.jsx